export default __webpack_public_path__ + "static/game-intro-bg-399d06e52785fa40bff5a91560e9cd14.png";